import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SharedDocumentsService } from '@app/shared/services/shared-documents.service';
import { IDocumentResponseDTO } from '@core/model';
import { ShellService } from '@mynexus/mfe-core';
import { ProductNames } from '@mynexus/mynexus-ui-lib';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DocumentsDmeposService extends SharedDocumentsService {
  constructor(
    http: HttpClient,
    shellService: ShellService,
  ) {
    super(http, shellService, ProductNames.DMEPOS);
  }

  override getFilesMetaData(tenantId: string, authorizationByProductId: string): Observable<IDocumentResponseDTO[]> {
    return this.http.get<IDocumentResponseDTO[]>(`${this.getBaseUrl(tenantId, authorizationByProductId)}/GetFilesMetaData`);
  }
}
